import { render, staticRenderFns } from "./EhrReferralPoolHistory.vue?vue&type=template&id=31fe3153"
import script from "./EhrReferralPoolHistory.vue?vue&type=script&lang=js"
export * from "./EhrReferralPoolHistory.vue?vue&type=script&lang=js"
import style0 from "./EhrReferralPoolHistory.vue?vue&type=style&index=0&id=31fe3153&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports